import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=3f0c6e4a&scoped=true&"
import script from "./Search.vue?vue&type=script&setup=true&lang=js&"
export * from "./Search.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0c6e4a",
  null
  
)

export default component.exports